export default __webpack_public_path__ + "static/media/playstore.18632a65.svg";